/** 提示模式 */
export enum TipsModeEnum {
  // 默认
  default = 'default',
  // 保存
  save = 'save',
  // 超时（30分钟没有操作）
  timeout = 'timeout',
  // 网络连接失败
  networkError = 'networkError',
}

// 保存模式
export enum SaveModeEnum {
  // 自动
  auto = 'auto',
  // 操作
  operation = 'operation',
}

/** 是否多语言枚举 */
export enum IsMultilingualEnum {
  /** 多语言 */
  multilingual = 1,
  /** 单语言 */
  monolingual = 0,
}

// 离开弹窗由谁触发
export enum WhoLeaveEnum {
  NORMAL = 'normal',
  DOMAIN_AUTH = 'domainAuth',
}

export enum VariableTypeEnum {
  // 0-all  1-静态变量列表  2-动态变量列表 3-联系人
  ALL = 0,
  STATIC = 1,
  DYNAMIC = 2,
  CONTACT = 3,
}

export enum PlaceholderTypeEnum {
  /** 全部 */
  ALL = 0,
  /** 资源码 */
  SOURCE_CODE = 1,
  /** 联系人字段 */
  CONTACT_FIELD = 2,
}

// 编辑器模式(light、dark)
export const EDITOR_THEME = 'editor-theme';

// 编辑器主题枚举
export enum EditorThemeEnum {
  LIGHT = 'light',
  DARK = 'dark',
}
